import {flow, getEnv, types} from 'mobx-state-tree'
import Parameter from "../../../models/Parameter";


const GS1ParamsStore = types.model('GS1ParamsStore', {
  storeUuid: types.identifier,
  list: types.optional(types.array(Parameter), []),
}).actions((self) => ({

  initWithData(parameters = []) {
    if (parameters) {
      self.setList(parameters)
    } else {
      self.setList("")
    }
  },
  setList(list) {
    if (list) {
      self.list = list.map(p => Parameter.create({
        uuid: p?.uuid,
        name: p?.name,
        label: p?.label,
      })).sort((a, b) => a.label.localeCompare(b.label));

    } else {
      self.list = []
    }
  },
})).views((self) => ({
  getGS1Parameters() {
    return self.list
  }
}))


export default GS1ParamsStore;
